import React from 'react'
import { Block, Container, Form } from '@components'

const DatoCmsCta = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <Container>
        <Form {...props} />
      </Container>
    </Block>
  )
}

export default DatoCmsCta
